// Copyright (c) 2020, Picsa Advisory Services (Pty) Ltd. All rights reserved

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Mutation } from 'react-apollo'
import gql from 'graphql-tag'
import { isEmpty } from 'lodash'

import {
  ProgressIndicator,
  Input,
  Button,
  Spinner,
  SelectEmployerEmployees
} from '../../'

import { decodeBase64 } from '../../../utils'

import { MaxLengthInputLabel } from './MaxLengthInputLabel'

const NAME_AND_DESCRIPTION = 1
const EMPLOYEES = 2

const MUTATION_BULKMESSAGE_AUDIENCE = gql`
  mutation ($input: BulkMessageAudienceMutationInput!) {
    bulkmessageaudienceMutate(input: $input) {
      bulkmessageaudience {
        id
        name
        description
        identities {
          totalCount
          edges {
            node {
              id
            }
          }
        }
      }
    }
  }
`


export class AudienceAdd extends Component {
  static propTypes = {
    employerId: PropTypes.string,
    employerGroupId: PropTypes.string,
    onInitiate: PropTypes.func,
    onComplete: PropTypes.func
  }

  static defaultProps = {
    className: ''
  }

  state = {
    currentStep: NAME_AND_DESCRIPTION,
    name: '',
    description: '',
    employees: [],
    audiendId: null,
    saveInProgress: false
  }

  showStepAssociatedContent = (stepNumber) => this.setState({ currentStep: stepNumber })

  saveAndGoToMemberSelectionStep = (bulkmessageaudienceMutate) => {
    let input = {
      name: this.state.name,
      description: this.state.description
    }

    if (this.props.employerId) {
      input.employer = this.props.employerId
    }
    if (this.props.employerGroupId) {
      input.employergroup = this.props.employerGroupId
    }

    bulkmessageaudienceMutate({
      variables: { input }
    })
    .then(({ data }) => (
      this.setState({
        currentStep: EMPLOYEES,
        audienceId: data.bulkmessageaudienceMutate.bulkmessageaudience.id
      })
    ))
    .catch(error => null)
  }

  saveSelectedMembers = (employees, bulkmessageaudienceMutate, identityQueryFilters={}, closeOriginatorModal) => {
    if (closeOriginatorModal) {
      closeOriginatorModal()
    }

    this.setState(
      { saveInProgress: true },
      () => {
        let input = {
          id: this.state.audienceId,
          // identities: employees.map(employeeId => decodeBase64(employeeId))
        }

        if (isEmpty(identityQueryFilters)) {
          input.identities = employees.map(employeeId => decodeBase64(employeeId))
        } else {
          input.identityQueryFilters = JSON.stringify(identityQueryFilters)
        }

        bulkmessageaudienceMutate({ variables: { input } })
        .then(() => {
          this.setState(
            { saveInProgress: false },
            this.props.onComplete
          )
        })
        .catch(error => this.setState({ saveInProgress: false }))
      }
    )
  }

  handleInputChange = (e) => {
    const inputName = e.target.id

    this.setState({ [inputName]: e.target.value })
  }

  render() {
    const progressSteps = [
      {
        name: "Name & Description",
        state: this.state.currentStep === EMPLOYEES
          ? "completed"
          : "active",
        onClick: () => this.showStepAssociatedContent(NAME_AND_DESCRIPTION)
      },
      {
        name: "Employees",
        state: this.state.currentStep === EMPLOYEES
          ? "active"
          : null,
        onClick: () => this.showStepAssociatedContent(EMPLOYEES)
      }
    ]

    return (
      <div className={`slds-p-top_small slds-p-left_small slds-p-right_small slds-p-bottom_small ${this.props.className}`}>
        <ProgressIndicator
          steps={progressSteps}
          displayStepNames={false}
          className='slds-size_1-of-2'
        />
        {this.state.saveInProgress &&
          <Spinner type='brand' size='large' />
        }
        <div className={`slds-m-top_medium ${this.state.currentStep === NAME_AND_DESCRIPTION ? 'slds-align_absolute-center' : ''}`}>
          {this.state.currentStep === NAME_AND_DESCRIPTION
            ? <div className='slds-size_1-of-2'>
                <Input
                  id="name"
                  label={
                    <MaxLengthInputLabel
                      name="Name"
                      maxLength={35}
                      maxLengthExceeded={this.state.name.length > 35}
                    />
                  }
                  value={this.state.name}
                  onChange={this.handleInputChange}
                  hasError={this.state.name.length > 35}
                  className='u-font-size-larger slds-m-bottom_medium'
                />
                <Input
                  id="description"
                  label={
                    <MaxLengthInputLabel
                      name="Description"
                      maxLength={75}
                      maxLengthExceeded={this.state.description.length > 75}
                    />
                  }
                  value={this.state.description}
                  onChange={this.handleInputChange}
                  hasError={this.state.description.length > 75}
                  className='u-font-size-larger'
                />
                <Mutation mutation={MUTATION_BULKMESSAGE_AUDIENCE}>
                  {bulkmessageaudienceMutate => (
                    <Button
                      type='brand'
                      disabled={this.state.name.length === 0 || this.state.description.length === 0}
                      onClick={() => this.saveAndGoToMemberSelectionStep(bulkmessageaudienceMutate)}
                      className='slds-m-top_xx-large'
                      style={{ width: '100%' }}>
                      Choose audience members
                    </Button>
                  )}
                </Mutation>
              </div>
            : <Mutation mutation={MUTATION_BULKMESSAGE_AUDIENCE}>
                {(bulkmessageaudienceMutate, { data }) => (
                  <SelectEmployerEmployees
                    selected={this.state.employees}
                    onSelectionChange={(employees, identityQueryFilters, closeOriginatorModal) => (
                      this.saveSelectedMembers(
                        employees,
                        bulkmessageaudienceMutate,
                        identityQueryFilters,
                        closeOriginatorModal
                      )
                    )}
                    className='slds-p-top_medium slds-p-bottom_medium slds-p-right_small'
                  />
                )}
              </Mutation>
          }
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/messageplus/employer-bulk-sms-audiences/AudienceAdd.js